module.exports = __webpack_public_path__ + "img/networkBenefits.76edec76.jpeg";